import { defineOutcome, type CatalogOutcomeDefinitionMap } from './catalogCapabilities.types';

export const commerceCatalogOutcomeDefinitions: CatalogOutcomeDefinitionMap = {
  airbnb: [
    defineOutcome('Find Airbnb stays', 'Listings, total prices, ratings, hosts, and guest filters', 'airbnb.search'),
  ],
  alibaba: [
    defineOutcome('Source wholesale products', 'Listings, price ranges, minimum orders, and suppliers', 'alibaba.search'),
  ],
  amazon: [
    defineOutcome('Research products and pricing', 'Product details, ASIN lookups, prices, ratings, and attributes', 'amazon.product', 'amazon.asins'),
    defineOutcome('Discover products and trends', 'Search results, categories, and bestseller rankings', 'amazon.search', 'amazon.bestsellers'),
    defineOutcome('Analyze customer feedback', 'Review ratings, text, dates, and verified purchases', 'amazon.reviews'),
  ],
  appstore: [
    defineOutcome('Analyze App Store reviews', 'Ratings, review titles, text, and storefront countries', 'appstore.reviews'),
  ],
  booking: [
    defineOutcome('Find Booking.com stays', 'Hotels, prices, scores, locations, and occupancy filters', 'booking.search'),
  ],
  capterra: [
    defineOutcome('Analyze software reviews', 'Overall and sub-ratings, pros and cons, reviewer job title, company size, and industry', 'capterra.reviews'),
  ],
  ebay: [
    defineOutcome('Research active listings', 'Prices, conditions, shipping, sellers, and listing types', 'ebay.search'),
    defineOutcome('Analyze sold prices', 'Recent sales, prices, dates, conditions, and item details', 'ebay.sold_listings'),
    defineOutcome('Look up one listing', 'Price, condition, shipping, quantity, watchers, bids, and seller feedback', 'ebay.product'),
    defineOutcome('Read full item details', 'Item specifics, seller description, all images, and category', 'ebay.product_full'),
  ],
  fiverr: [
    defineOutcome('Research freelance services', 'Gigs, sellers, ratings, pricing, and categories', 'fiverr.search'),
  ],
  g2: [
    defineOutcome('Analyze software reputation', 'Star ratings, what reviewers like and dislike, market segment, and G2 rubric scores', 'g2.reviews'),
  ],
  google_hotels: [
    defineOutcome('Compare hotel prices', 'Hotels, nightly prices, booking sites, ratings, star class, and amenities', 'google_hotels.search', 'google_hotels.details'),
  ],
  google_shopping: [
    defineOutcome('Compare product offers', 'Products, prices, stores, ratings, and localized links', 'google_shopping.search'),
  ],
  playstore: [
    defineOutcome('Analyze Google Play reviews', 'Ratings, review text, authors, and app feedback', 'playstore.reviews'),
  ],
  tiktok_shop: [
    defineOutcome('Research products and sellers', 'Product details, prices, sales, ratings, and sellers', 'tiktok_shop.product', 'tiktok_shop.shop_products'),
    defineOutcome('Discover products and creators', 'Keyword search, store catalogs, and creator showcases', 'tiktok_shop.search', 'tiktok_shop.shop_products', 'tiktok_shop.user_showcase'),
    defineOutcome('Analyze customer feedback', 'Product reviews, ratings, text, and verified purchases', 'tiktok_shop.product_reviews'),
  ],
  tripadvisor: [
    defineOutcome('Discover places to visit', 'Hotels, restaurants, attractions, ratings, and review counts', 'tripadvisor.search'),
    defineOutcome('Analyze traveler feedback', 'Reviews, ratings, dates, and trip details', 'tripadvisor.reviews'),
  ],
  trustpilot: [
    defineOutcome('Analyze company reputation', 'Star ratings, review text, dates, and reviewer details', 'trustpilot.reviews'),
  ],
  walmart: [
    defineOutcome('Research Walmart products', 'Prices, availability, ratings, images, and specifications', 'walmart.product'),
  ],
};
